"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const sale = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-sale` : '') + (description ? ` desc-sale` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-sale"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-sale"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M1 2.65678V9.56886C1.00019 10.4476 1.34942 11.2903 1.97087 11.9115L14.8164 24.7571C14.9224 24.8632 15.0552 24.9385 15.2007 24.9751C15.3461 25.0116 15.4988 25.0079 15.6423 24.9645C15.7859 24.9211 15.9149 24.8395 16.0157 24.7285C16.1166 24.6174 16.1853 24.4811 16.2148 24.3341L17.5678 17.5678L24.3341 16.2148C24.4811 16.1853 24.6174 16.1166 24.7285 16.0157C24.8395 15.9149 24.9211 15.7859 24.9645 15.6423C25.0079 15.4988 25.0116 15.3461 24.9751 15.2007C24.9385 15.0552 24.8632 14.9224 24.7571 14.8164L11.9115 1.97087C11.2903 1.34942 10.4476 1.00019 9.56886 1H2.65678C2.21737 1 1.79597 1.17455 1.48526 1.48526C1.17455 1.79597 1 2.21737 1 2.65678Z",
    stroke: "black",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M5.14185 6.79873C5.14185 7.23814 5.3164 7.65955 5.6271 7.97025C5.93781 8.28096 6.35922 8.45551 6.79862 8.45551C7.23803 8.45551 7.65944 8.28096 7.97014 7.97025C8.28085 7.65955 8.4554 7.23814 8.4554 6.79873C8.4554 6.35933 8.28085 5.93792 7.97014 5.62721C7.65944 5.31651 7.23803 5.14195 6.79862 5.14195C6.35922 5.14195 5.93781 5.31651 5.6271 5.62721C5.3164 5.93792 5.14185 6.35933 5.14185 6.79873Z",
    stroke: "black",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
var _default = exports.default = sale;